<template>
      <card-seplag titulo="Manter Questionario"  cor="#00acc1" >   

      <Rotulo nome="Descrição do Questionário:" cols="12" >
          <InputText type="text" v-model="questionario.descQuestionario" v-required  />
      </Rotulo>

        <div class="p-col-12 p-md-3" v-if="questionario.idenQuestionario  === undefined">
                  <Button label="Salvar" icon="pi pi-check" class="p-button-rounded p-button-success" @click="salvarQuestionario()"/>
        </div>
        <div class="p-col-12 p-md-3" v-if="questionario.idenQuestionario !== undefined">
                  <Button label="Alterar" icon="pi pi-check" class="p-button-rounded  p-button-warning" @click="AlterarQuestionario()"/>
        </div>
      <div class="p-col-12" >
        <Fieldset legend="Perguntas" >
          <div class="p-col-12 p-md-3 p-md-offset-9" v-if="questionario.idenQuestionario !== undefined">                    
              <Button label="Nova Pergunta do Questionário" icon="pi pi-check" class="p-button-rounded" @click="novaPergunta()"/>
          </div>
          <table-seplag :dados.sync="questionario.questionarioPerguntas"  :exibirCabecalho="false" v-if="questionario.idenQuestionario !== undefined"
           
           >
            <!-- <Column bodyStyle="text-align: center" header="Perguntas Ativas" :headerStyle="'width: 8em'">
                <template #body="slotProps">                                     
                    <Checkbox :id="slotProps.data.pergunta.idenPergunta" :name="slotProps.data.descPergunta" :value="slotProps.data" v-model="perguntasCheckbox"  />
                </template>
            </Column> -->
            <Column bodyStyle="text-align: center" header="Descrição">
                <template #body="slotProps">                                     
                  {{slotProps.data.pergunta.descPergunta}}
                </template>
            </Column>
            <Column bodyStyle="text-align: center" header="Tipo" >
                <template #body="slotProps">                                     
                  {{slotProps.data.pergunta.tipoPergunta.descTipoPergunta}}
                </template>
            </Column>
            <Column bodyStyle="text-align: center" header="Categoria">
                <template #body="slotProps">                                     
                  {{slotProps.data.categoriaPergunta.descrCategoriaPergunta}}
                </template>
            </Column>
             <Column
            bodyStyle="text-align: center"
            headerStyle="width: 15em;"
            class="p-grid"
          >
            <template #body="linha">
              <Button
                v-tooltip="'desvincular Pergunta desse questionário'"
                icon="pi pi-times"
                class="p-button-rounded p-button-danger margin-botao"
                @click="inativarPerguntaQuestionario(linha.data)"
                v-if="linha.data.statQuestionarioPergunta==='ATIVO'"
                label="Desvincular do Questionário"
               />
             <Button
                v-tooltip="'vincular Pergunta a esse questionário'"
                icon="pi pi-check"
                class="p-button-rounded  p-button-success margin-botao"
                @click="ativarPerguntaQuestionario(linha.data)"
                v-if="linha.data.statQuestionarioPergunta==='INATIVO'"
                 label="Vincular ao Questionário"
              />
            </template>
          </Column>
          </table-seplag>
          <h2 v-if="questionario.idenQuestionario === undefined">Primeiro salve o questionario acima para poder vincular perguntas </h2>
        </Fieldset>
      </div>
      <div class="p-col-12">
          <div class="p-grid p-fluid">
              <div class="p-col-12 p-md-3">
                  <Button label="Voltar" icon="pi pi-arrow-left" class="p-button-rounded" @click="voltarNovoCiclo()"/>
              </div>
         <!--      <div class="p-col-12 p-md-3">
                  <Button label="Salvar Perguntas" icon="pi pi-check" class="p-button-rounded p-button-success" @click="salvarPerguntaNoQuestionario()"/>
              </div> -->
          </div>
      </div>
    </card-seplag>     
</template>
<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import TableSeplag from '@/template/TableSeplag.vue'
import { baseApiUrl } from '@/config/global'

export default {
    name: "gerenciaNovoQuestionario",
    components: {CardSeplag,Rotulo,TableSeplag,},
    data: function(){        
		return {
      questionario:{ descQuestionario: null, statQuestionario: null, idenQuestionario: undefined,   questionarioPerguntas: [] },
       perguntaSelecionadasParaQuestionario: [],
       sistemaQuestionario : {sistema: { idenSistema: null }, questionario: { idenQuestionario :0}, statQuestSistema:"ATIVO"},
       perguntasCheckbox : [],
       responseQuestionario : null,
       
      };     
},
    methods:{     
       carregarDados(){ 
        this.perguntaSelecionadasParaQuestionario =  JSON.parse(
        JSON.stringify(this.$store.getters.getNovasperguntaSelecionadasParaQuestionario));      
        this.questionario =  JSON.parse(
        JSON.stringify(this.$store.getters.getQuestionarioSelecionado));
        this.questionario.questionarioPerguntas = JSON.parse(
        JSON.stringify(this.$store.getters.getQuestionarioSelecionado.questionarioPerguntas));

        if (this.perguntaSelecionadasParaQuestionario.length > 0 ) {
          this.perguntaSelecionadasParaQuestionario.forEach(element => 
            this.questionario.questionarioPerguntas.push(element)
          )
          this.perguntaSelecionadasParaQuestionario.length = 0;
        }
      },
      novaPergunta(){
        // this.$$store.commit('setPerguntasQuestionario', this.questionarioPerguntas)
        // this.$store.commit('setQuestionarioSelecionado', this.questionario)
        this.$router.push({name:'novoQuestionarioPergunta'})
      },
      voltarNovoCiclo(){
        this.$router.push({name:'gerenciaNovoCiclo'})
      },
     async salvarQuestionario(){
        this.questionario.statQuestionario = "ATIVO";
      this.responseQuestionario = await this.$http
        .post(`${baseApiUrl}/questionarios`, JSON.stringify(this.questionario))
        .then((res) => {
          this.sistemaQuestionario.sistema.idenSistema = 3;
          this.sistemaQuestionario.questionario.idenQuestionario = res.data.idenQuestionario;
          this.questionario = res.data
          this.$store.commit('setQuestionarioSelecionado', this.questionario)

           this.$http
          .post(`${baseApiUrl}/questsistemas`, JSON.stringify(this.sistemaQuestionario))
               
          this.$toast.add({severity:'success', summary: 'Aviso', detail:'Questionário salvo com sucesso', life: 4000});

        })


      },

      async inativarPerguntaQuestionario(data) {
         await this.$http
        .put(`${baseApiUrl}/questionarioperguntas/status/${data.idenQuestionarioPergunta}/inativo`)
        .then(() => {
          
          this.$toast.add({severity:'success', summary: 'Aviso', detail:'Pergunta inativada com sucesso', life: 4000});
        })
        this.questionario.questionarioPerguntas.forEach(
          element =>  { 
            if(element.idenQuestionarioPergunta === data.idenQuestionarioPergunta) {
                
                element.statQuestionarioPergunta = "INATIVO"

            }
          }
         )
       
       this.$store.commit('setQuestionarioSelecionado', this.questionario)

      },
       ativarPerguntaQuestionario(data) {
        
         this.$http
        .put(`${baseApiUrl}/questionarioperguntas/status/${data.idenQuestionarioPergunta}/ativo`)
        .then(() => {
          
          this.$toast.add({severity:'success', summary: 'Aviso', detail:'Pergunta ativa com sucesso', life: 4000});
        })

       this.questionario.questionarioPerguntas.forEach(
          element => { if 
             (element.idenQuestionarioPergunta === data.idenQuestionarioPergunta) {
                
                element.statQuestionarioPergunta = "ATIVO"

             }
          }
        )
       this.$store.commit('setQuestionarioSelecionado', this.questionario)
      }
    },
    mounted(){        
        this.carregarDados()
    }

}
</script>

<style>

</style>